<template>
  <div>
    <div class="bg-white p-2">
      <div class="text-center pt-4">
        <div>
          <span> Prompt Template Id </span>
          <input type="number" id="PromptTemplateId" value="1" />
          <span
            >1 Default 2 For KFC 3 prefix price รวมภาษีมูลค่าเพิ่มแล้ว 4 Prefix
            Invoice 'No.' 5 Prefix Invoice 'Slip#' 6 Prefix Date: Time:</span
          >
        </div>
        <div>
          <input type="file" @change="someOtherFunction" />
        </div>
        <div class="text-center">
          <img class="image-size" v-bind:src="imageBase64" />
        </div>
      </div>
      <div>
        Time using : <label id="minutes">00</label>:<label id="seconds"
          >00s</label
        >
      </div>
      <div v-if="errortext" class="text-danger">
        {{ errortext }}
      </div>

      <hr />
      <div class="mt-4">
        <pre>{{ resultBody }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      invoiceNo: "",
      total: null,

      imageBase64: "",
      resultBody: null,
      totalSeconds: 0,
      timeInterVal: null,

      errortext: ""
    };
  },
  methods: {
    handleFileUpload(event) {
      return new Promise((resolve, reject) => {
        const fileInput = event.target;
        if (!fileInput.files.length) {
          reject(new Error("No file selected"));
          return;
        }

        const reader = new FileReader();

        reader.onload = () => {
          // Extract the base64 string without the data URL prefix
          const base64String = reader.result;
          resolve(base64String);
        };

        reader.onerror = error => {
          reject(error);
        };

        // Read the file as a data URL
        reader.readAsDataURL(fileInput.files[0]);
      });
    },
    async someOtherFunction(event) {
      try {
        const base64String = await this.handleFileUpload(event);
        console.log("Base64 string:", base64String);
        this.imageBase64 = base64String;
        this.callApi(base64String);
        // You can use the base64String as needed.
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
    async callApi(base64) {
      let ddd = document.getElementById("PromptTemplateId").value;

      var body = {
        IsShowResponseDetail: true,
        Base64: base64.split(",")[1],
        PromptTemplateId: ddd,
        ImagePath: "",
        BrandCode: ""
      };

      this.invoiceNo = null;
      this.total = null;
      this.totalSeconds = 0;
      this.resultBody = null;
      this.errortext = "";

      this.timeInterVal = setInterval(this.setTime, 1000);

      await this.axios
        .post(`${this.$baseUrl}/ReceiptDetection/test`, body)
        .then(res => {
          this.resultBody = res.data;
          clearInterval(this.timeInterVal);
        })
        .catch(error => {
          console.log("error", error);
          this.errortext = "error : " + error;
          this.invoiceNo = "Error";
          this.total = "Error";
          this.totalSeconds = 0;
          this.resultBody = null;
          clearInterval(this.timeInterVal);
        });
    },
    pad(val) {
      var valString = val + "";
      if (valString.length < 2) {
        return "0" + valString;
      } else {
        return valString;
      }
    },
    setTime() {
      ++this.totalSeconds;
      document.getElementById("seconds").innerHTML = this.pad(
        this.totalSeconds % 60
      );
      document.getElementById("minutes").innerHTML = this.pad(
        parseInt(this.totalSeconds / 60)
      );
    }
  }
};
</script>

<style>
.image-size {
  width: 300px;
}
</style>
